import React from 'react';

const ErrorPage = () => {
  return <h1>СТРАНИЦА НЕ НАЙДЕНА</h1>;
};

export { ErrorPage };
